import { theme } from '../theme/theme';
import { IconKeys } from '../components/common/Icon/IconKeys';

export function getDeviceConfigStatusDisplay(
  status: string | null | undefined,
  isLoading: boolean,
  isError: boolean,
): { icon: IconKeys; color?: string; text: string; textColor?: string } {
  if (isLoading) {
    return {
      icon: IconKeys.SYNC_PENDING,
      color: theme.colors.orange,
      text: 'Checking...',
      textColor: 'black',
    };
  }

  if (isError || !status) {
    return {
      icon: IconKeys.SYNC_FAILED,
      color: theme.colors.red,
      text: 'Status unavailable',
      textColor: 'black',
    };
  }

  const normalized = status.toLowerCase();

  switch (normalized) {
    case 'success_fw':
    case 'success':
      return {
        icon: IconKeys.SYNCED,
        color: theme.colors.green,
        text: 'Synced',
        textColor: 'black',
      };

    case 'init_fw':
    case 'init':
      return {
        icon: IconKeys.SYNC_PENDING,
        color: theme.colors.orange,
        text: 'Sync in progress',
        textColor: 'black',
      };

    case 'failed':
    case 'failed_fw':
      return {
        icon: IconKeys.SYNC_FAILED,
        color: theme.colors.red,
        text: 'Sync failed',
        textColor: 'black',
      };

    default:
      return {
        icon: IconKeys.SYNC_NOTFOUND,
        text: 'No config status',
        textColor: 'white',
      };
  }
}
